import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'lib-stat-card',
  templateUrl: './stat-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatCard {
  readonly count = input.required<number>();
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly colorScheme = input<'teal' | 'amber' | null>(null);
  readonly testId = input<string | undefined>(undefined);

  protected readonly highlighted = computed(() => this.colorScheme() !== null && this.count() > 0);

  protected readonly iconClass = computed(() => {
    const scheme = this.colorScheme();
    const color =
      scheme === 'teal'
        ? 'text-teal-600'
        : scheme === 'amber'
          ? 'text-amber-600'
          : 'text-slate-600';
    return `pi ${this.icon()} ${color}`;
  });
}
